import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GridSettingsMapperService {

  constructor(private readonly http: HttpClient) { }


    saveTableSettings(category: string, data: any){
      return this.http.post<any>(`${environment.main_url}/agilelegal/gridmappings/${category}`, data)
    }
}
